import React from 'react'
import union from 'lodash/union'
import map from 'lodash/map'

const ShowCategories = (props) => {
  const categoriesWithAreas = union(...map(props.therapy_areas, 'categories'))
  const getCategory = cat => cat || {};

  return <div className="row categoryRow">

    {categoriesWithAreas.map(catId => props.therapy_categories[catId] && <div
      onClick={()=>{
        props.click(catId)
      }}
      className={"category-container "+ (props.active_category === catId && 'active')} key={catId}>
      { getCategory(props.therapy_categories[catId]).image ?
        <img
          alt={getCategory(props.therapy_categories[catId]).name}
          title={getCategory(props.therapy_categories[catId]).name}
          className="category-icon"
          src={require('../../images/icons/categories/'+getCategory(props.therapy_categories[catId]).image)} />
          :
          <span>...</span>

      }
        <span>{ getCategory(props.therapy_categories[catId]).name}</span>
      </div>
    )}
  </div>
}


ShowCategories.defaultProps = {
  therapy_categories:{},
  therapy_areas: [],
  click: ()=>{}
}

export default ShowCategories;

/*
<ul>
{ props.therapy_areas
    .filter(area => area.categories.indexOf(catId) !== -1)
    .map(area => <li>{area.name}</li>)
  }
</ul>
*/



// WEBPACK FOOTER //
// ./src/components/ui/ShowCategories.jsx